<!--Da documentazione siteimprove accessibility checker-->
<!--
	Ensure all perceivable text is included in an ARIA landmark.
	The <nav> element automatically communicates that a section has a role of navigation.

	Esempio con <nav>:
	<nav id="nav" aria-label="Main menu">
	  <ul>
	    <li><a href="page1.html">Home</a></li>
	    <li><a href="page2.html">Shop</a></li>
	    <li><a href="page3.html">Blog</a></li>
	  </ul>
	</nav>

	Esempio con <div>:
	<div role="region" aria-label="Weather"> ...</div>
-->
<div class="test">
	<p>Test interceptors</p>

	<button (click)="loadSuccess()">GET 200</button>
	<button (click)="loadForbidden()">GET 403</button>
	<button (click)="loadNotFound()">GET 404</button>

	<hr>

	<div role="region" aria-label="Demo componenti">
		<h2>Demo componenti</h2> <!--Per header e paragrafi non serve l'accessibilità, è già gestita in automatico-->

		<h3>Autocomplete</h3>

		<mat-form-field class="example-full-width" appearance="outline">
		  <mat-label>Animale</mat-label> <!--mat-label gestisce da solo aria-label, in questo caso non serve inserire altro-->
		  <input #animalinput
		    type="text"
			placeholder="Seleziona un animale"
		    matInput
			[matAutocomplete]="auto"
		    (input)="filter()"
		    (focus)="filter()"> <!--Per l'input anche, viene gestito tutto in automatico-->

		  <button mat-icon-button matSuffix aria-label="Apri selezione animale"> <!--Trattandosi di una semplice icona, specificare tramite aria-label il suo utilizzo-->
		    <mat-icon>pets</mat-icon>
		  </button>

		  <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn">
		    @for (option of filteredAnimalOptions; track option) {
		      <mat-option [value]="option" aria-label="{{option.name}}">{{option.name}}</mat-option>
					<!--In questo caso non abbiamo una mat-label, 
					quindi dobbiamo dichiarare la label di ogni opzione aria-label="{{option.name}}"-->
		    }
		  </mat-autocomplete>
		</mat-form-field>

		<hr>

		<h3>Badge</h3>

		<button
	  		mat-icon-button
	  		aria-label="Notifiche"
	  		[matBadge]="notifications"
	  		[matBadgeHidden]="!notifications"
	  		[matBadgeDescription]="'Hai x nuove notifiche'"
	  		matBadgePosition="above after"
	  		matBadgeColor="warn"
			>
	  		<!-- <i class="fa-regular fa-bell"></i> -->
	  		<mat-icon>notifications</mat-icon>
		</button>

		<button
	  		mat-icon-button
	  		aria-label="Notifiche"
	  		[matBadge]="messages"
	  		[matBadgeHidden]="!messages"
	  		[matBadgeDescription]="'Hai x nuove notifiche'"
	  		matBadgePosition="above after"
	  		matBadgeColor="warn"
			>
	  		<!-- <i class="fa-regular fa-bell"></i> -->
	  		<mat-icon>mail</mat-icon>
		</button>

		<button aria-label="Profilo" class="profile-button">
		    <img src="assets/user.jpg" alt="Profilo" class="profile-image"/>
		</button>

		<hr>

		<h3>Buttons</h3>

		<!-- Bottone testuale, l'accessibilità è già implementata di default da material-->
		<button matButton>Text</button>
		<button matButton disabled="true">Text disabled</button>

		<br>

		<!-- Bottone con sola icona, è buona norma aggiungere un aria label a descrivere la funzionalità -->
		<button mat-icon-button aria-label="Impostazioni">
		  <mat-icon>settings</mat-icon>
		</button>

		<br>

		<!--Button filled-->
		<button matButton="filled">
			<span>Filled</span>
		</button>
		<button matButton="filled" disabled="true">
			<span>Filled disabled</span>
		</button>

		<br>

		<!--Button outlined-->
		<button matButton="outlined">
			<span>Outlined</span>
		</button>

		<button matButton="outlined" disabled="true">
			<span>Outlined disabled</span>
		</button>


		<hr>

		<h3>Buttons toggle</h3>

		<mat-button-toggle-group name="fontStyle" aria-label="Font Style">
		  <mat-button-toggle value="bold">Bold</mat-button-toggle>
		  <mat-button-toggle value="italic">Italic</mat-button-toggle>
		  <mat-button-toggle value="underline">Underline</mat-button-toggle>
		</mat-button-toggle-group>

		<!--Come per i casi precedenti, se non sono presenti label aggiungere aria-label o aria-describedby-->
		<!-- es.caso in cui c'è solo una icon senza testo -->
		<hr>

		<h3>Cards</h3>
		<!-- 
			Per le card, come scritto nella documentazione, ci sono molteplici opzioni per gestirla.
			Il tutto dipende dall'utilizzo dello stesso mat-card e degli elementi al suo interno,
			i quali seguono le logiche dei singoli componenti angular (es. alt per la descrizione dell'immagine)
			Per maggiori informazioni consultare documentazione:
			https://material.angular.dev/components/card/overview#accessibility 
		-->

		<mat-card class="example-card" appearance="outlined">
		  <mat-card-header>
		    <mat-card-title-group>
		      <mat-card-title>Shiba Inu</mat-card-title>
		      <mat-card-subtitle>Small</mat-card-subtitle>
		      <img mat-card-sm-image src="https://material.angular.dev/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu">
		    </mat-card-title-group>
		  </mat-card-header>
		  <mat-card-content>
		    The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from Japan. A small, 
				agile dog that copes very well with mountainous terrain, the Shiba Inu was originally bred for hunting.
		  </mat-card-content>
		</mat-card>

		<hr>

		<h3>Checkbox</h3>
		<section class="example-section">
		  <mat-checkbox class="example-margin">Check me!</mat-checkbox> 
		  <!--Acessibilità gia integrata, come negli altri casi da implementare solo se manca il testo-->
		  <mat-checkbox class="example-margin" [disabled]="true">Checkbox disabled true</mat-checkbox> 
		  <mat-checkbox class="example-margin" [disabled]="false">Checkbox disabled false</mat-checkbox>
		  <br>
		  <span>Checkbox senza testo per test accessibilità</span>
		  <mat-checkbox aria-label="Esempio di checkbox senza testo"></mat-checkbox>
		  <br>
		  <mat-checkbox class="checkbox-error">Test error</mat-checkbox>
		  <mat-checkbox class="checkbox-error" [disabled]="true">Test error disabled</mat-checkbox>
		</section>

		<hr>

		<h3>Chips</h3>

		<h4>Filter</h4>

		<mat-chip-set aria-label="Fish selection">
		  	<mat-chip-option selected="true">One fish</mat-chip-option>
		  	<mat-chip-option>Two fish</mat-chip-option>
		  	<mat-chip-option>Three fish</mat-chip-option>
		  	<mat-chip-option disabled>Four fish</mat-chip-option>

			<!--

			ESEMPIO DI UTILIZZO

			<mat-chip-option
	            (selectionChange)="onTipoTaskSelect($event, tipo.id)"
	            [selected]="checkTipoTaskSelected(tipo.id)">
	            {{ tipo.name }}
	        </mat-chip-option>

			 -->
		</mat-chip-set>

		<h4>Priority</h4>

		<ui-priority-status class="storico-priority" priority="Low"></ui-priority-status>
		<ui-priority-status class="storico-priority" priority="Medium"></ui-priority-status>
		<ui-priority-status class="storico-priority" priority="High"></ui-priority-status>
		<ui-priority-status class="storico-priority" priority="Undefined"></ui-priority-status>

		<hr>

		<h3>Date picker</h3>

		<!--
		Anche qua, amterial implementa da sè l'accessibilità. 
		Salvo casi particolari si può lasciare il componente così com'è
		-->

		<mat-form-field>
		  <mat-label>Choose a date</mat-label>
		  <input matInput [matDatepicker]="picker">
		  <mat-hint>MM/DD/YYYY</mat-hint>
		  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
		  <mat-datepicker #picker></mat-datepicker>
		</mat-form-field>

		<hr>

		<h3>Dialog</h3>
		<!--
		Trattandosi di un elemento composto da altri componenti, come per le card, implementare singolarmente
		l'accessibilità dove serve
		-->

		<!-- Bottone per aprire il dialog -->
		<button mat-button (click)="openDialog()">Open Dialog</button>

		<!-- Dialog -->
		<ng-template #dialogTemplate>
		  <h2 mat-dialog-title id="dialog-title">Dialog with elements</h2>
			<mat-dialog-content id="dialog-content">This dialog showcases the title, close, content and actions elements.</mat-dialog-content>
			<mat-dialog-actions>
			  <button matButton mat-dialog-close>Close</button>
			</mat-dialog-actions>
		</ng-template>

		<hr>

		<h3>Icons</h3>
		<!--Di default material imposta aria-hidden a true, ma in base alla casistica potremmo voler modificare-->

		<!--Icone decorative: Non serve dover descrivere l'icona-->
		<p><mat-icon>star</mat-icon> Preferiti<p>

		<!--Icone Interattive: Fanno parte ad esempio di un pulsante, non serve descriverla se non il bottone vero e proprio-->
		<button mat-icon-button aria-label="Apri menu di navigazione">
		  <mat-icon>menu</mat-icon>
		</button>
		<br>

		<!--Icona Informativa: La usiamo ad esempio per indicare lo stato di un processo, quindi ha senso voler descrivere l'icona-->
		<p><mat-icon aria-hidden="false" aria-label="Error" fontIcon="error"></mat-icon>Error</p>

		<hr>

		<h3>Input + Textarea</h3>

		<!--Esempio di campo input semplice-->
		<form class="example-form">
			<p>
		  		<mat-form-field appearance="fill">
		  		  	<mat-label>Fill form field</mat-label>
		  		  	<input matInput placeholder="Placeholder" [formControl]="debugField">
					<mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
					<mat-hint>Hint</mat-hint>

					<mat-error *ngIf="debugField.hasError('errorDebug')">
	    				Errore
	  				</mat-error>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="fill">
		  		  	<mat-label>Fill form field</mat-label>
					<mat-icon matPrefix>person</mat-icon>
		  		  	<input matInput placeholder="Placeholder">
					<mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="fill">
		  		  	<mat-label>Fill form field</mat-label>
		  		  	<input matInput placeholder="Placeholder">
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="fill">
		  		  	<mat-label>Fill form field</mat-label>
					<mat-icon matPrefix>person</mat-icon>
		  		  	<input matInput placeholder="Placeholder">
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="outline">
		  		  	<mat-label>Fill form field</mat-label>
		  		  	<input matInput placeholder="Placeholder" [formControl]="debugField">
					<mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
					<mat-hint>Hint</mat-hint>

					<mat-error *ngIf="debugField.hasError('errorDebug')">
	    				Errore
	  				</mat-error>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="outline">
		  		  	<mat-label>Fill form field</mat-label>
					<mat-icon matPrefix>person</mat-icon>
		  		  	<input matInput placeholder="Placeholder">
					<mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="outline">
		  		  	<mat-label>Fill form field</mat-label>
		  		  	<input matInput placeholder="Placeholder">
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
		  		<mat-form-field appearance="outline">
		  		  	<mat-label>Fill form field</mat-label>
					<mat-icon matPrefix>person</mat-icon>
		  		  	<input matInput placeholder="Placeholder">
					<mat-hint>Hint</mat-hint>
		  		</mat-form-field>
		  	</p>

			<p>
				<mat-form-field appearance="outline" class="searchbar">
					<mat-icon matPrefix>menu</mat-icon>
				  	<input matInput placeholder="Ricerca" [formControl]="debugField">
					<mat-icon matSuffix>search</mat-icon>
				</mat-form-field>
			</p>

		  <mat-form-field class="example-full-width">
		    <mat-label>Leave a comment</mat-label>
		    <textarea matInput placeholder="Ex. It makes me feel..."></textarea>
		  </mat-form-field>
		</form>

		<mat-form-field appearance="outline" >
			<mat-label>outline</mat-label>
			<input matInput type="text" value="Text" disabled="false"/>
		</mat-form-field>

		<!--Esempio avanzato per form con required(preso dalla demo del form qua sotto)-->

		<!-- <mat-form-field appearance="outline">
		  <mat-label>Email</mat-label>
		  <input matInput type="email" id="email" formControlName="email" placeholder="esempio@gmail.com" aria-required="true" aria-describedby="email-errors">
		</mat-form-field>
		@if (userProfileForm.get('email')?.invalid && userProfileForm.get('email')?.touched) {
			<div id="email-errors">
				@if (userProfileForm.get('email')?.errors?.['required']) {
					<div role="alert" aria-live="assertive">
			  	  <span style="color: red">Email è richiesta.</span>
			  	</div>
				}
				@if (userProfileForm.get('email')?.errors?.['email']) {
					<div role="alert" aria-live="assertive">
			  	  <span style="color: red">Formato email non valido.</span>
			  	</div>	
				}
			</div>
		} -->

		<hr>

		<h3>Paginator</h3>

		<!--Settare l'aria label specificando che si tratta di un componente per "selezionare" la pagina-->
		<mat-paginator [length]="100"
		              [pageSize]="10"
		              [pageSizeOptions]="[5, 10, 25, 100]"
		              aria-label="Select page">
		</mat-paginator>

		<hr>

		<h3>Radio buttons</h3>

		<mat-radio-group aria-label="Select an option" value="1">
		  <mat-radio-button value="1">Option 1</mat-radio-button> <!--Per le options, l'aria label è già fornita da material come se fosse un bottone normale-->
		  <mat-radio-button value="2">Option 2</mat-radio-button>
		</mat-radio-group>

		<br>

		<mat-radio-group aria-label="Select an option" value="1" disabled>
		  <mat-radio-button value="1">Disabled 1</mat-radio-button>
		  <mat-radio-button value="2">Disabled 2</mat-radio-button>
		</mat-radio-group>

		<hr>

		<h3>Select</h3>

		<mat-form-field appearance="outline">
		  <mat-label>Cibo preferito</mat-label>
		  <mat-select
		    name="favoriteFood"
		    aria-describedby="favoriteFoodHint">
		    @for (food of foods; track food) {
		      <mat-option [value]="food.value">{{ food.viewValue }}</mat-option>
		    }
		  </mat-select>
		  <mat-hint id="favoriteFoodHint">Choose your favorite food</mat-hint>
		</mat-form-field>

		<hr>

		<h3>Slide toggle</h3>
		<!--Accessibilità già gestita da material, aggiungere aria label per toggle senza label testuale-->
		<!--TODO: Aggiungere a documentazione-->
		<p><mat-slide-toggle>Slide me!</mat-slide-toggle></p>

		<hr>

		<h3>Table</h3>
		<!--TODO: Aggiungere a documentazione-->
		<!--Come nei casi precedenti, viene gestito in autonomia tutto da material. Aggiungere solo aria-label se necessario descrivere meglio qualcosa-->

		<table mat-table [dataSource]="dataSourceTable" class="mat-elevation-z8">

	  		<!-- Position Column -->
	  		<ng-container matColumnDef="position">
	  		  <th mat-header-cell *matHeaderCellDef> No. </th>
	  		  <td mat-cell *matCellDef="let element"> {{element.position}} </td>
	  		</ng-container>

	  		<!-- Name Column -->
	  		<ng-container matColumnDef="name">
	  		  <th mat-header-cell *matHeaderCellDef> Name </th>
	  		  <td mat-cell *matCellDef="let element"> {{element.name}} </td>
	  		</ng-container>

		  	<!-- Weight Column -->
		  	<ng-container matColumnDef="weight">
		  	  <th mat-header-cell *matHeaderCellDef> Weight </th>
		  	  <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
		  	</ng-container>

		  	<!-- Symbol Column -->
		  	<ng-container matColumnDef="symbol">
		  	  <th mat-header-cell *matHeaderCellDef> Symbol </th>
		  	  <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
		  	</ng-container>

		  	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		  	<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>

		<hr>

		<h3>List-page</h3>

		<ui-list-page
			[columnsInfo]="columnsInfo"
			[dataSource]="dataSource"
			[dataTransform]="dataTransform"
			[gridItemTemplate]="gridItemTemplate"
			currentSortColumn="titolo"
			currentSortDirection="asc"
		>
		</ui-list-page>

		<ng-template #gridItemTemplate let-item="itemData">
			<!-- TODO: sistemare UI card -->
			<mat-card class="card" appearance="outlined">
			<div class="card-header">
				<ui-priority-status [priority]="item.priority"></ui-priority-status>
				<div >
					<div>{{(item.dataTask | date: 'dd/MM/yyyy HH:mm' : 'UTC' ) || '-' }}</div>
					<div>{{item.primaryRole.name}}</div>
				</div>
			</div>
			<mat-card-header>
				<mat-card-title> {{item.titolo}}</mat-card-title>
				<mat-card-subtitle> {{item.nome}}</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>
				<p> {{item.descrizione}} </p>
				<p> {{item.notaUtente}} </p>
			</mat-card-content>
			</mat-card>
		</ng-template> 

		<hr>


		<h3>Seachbar</h3>
		<p>TODO: Riposiaionare una searchbar</p>

		<hr>
	</div> 
	<div role="region" aria-label="Demo form">
		<h2>Demo form</h2>

		<form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()">
		  <h3 id="user-data">Dati utente</h3>
		  <mat-form-field appearance="outline">
		    <mat-label>Nome</mat-label>
		    <input matInput id="firstName" formControlName="firstName" aria-required="true" aria-describedby="firstName-errors">
		  </mat-form-field>
			@if (userProfileForm.get('firstName')?.invalid && userProfileForm.get('firstName')?.touched) {
				<div id="firstName-errors">
					@if (userProfileForm.get('firstName')?.errors?.['required']){
						<div role="alert" aria-live="assertive">
							<span style="color: red">Nome è richiesto.</span>
		  	  	</div>
					}
					@if (userProfileForm.get('firstName')?.errors?.['minlength']){
						<div role="alert" aria-live="assertive">
		  	  	  <span style="color: red">Nome deve avere almeno 3 caratteri.</span>
		  	  	</div>
					}	
		  	</div>
			}

		  <mat-form-field appearance="outline">
		    <mat-label>Cognome</mat-label>
		    <input matInput id="lastName" formControlName="lastName" aria-required="true" aria-describedby="lastName-errors">
		  </mat-form-field>
			@if (userProfileForm.get('lastName')?.invalid && userProfileForm.get('lastName')?.touched) {
				<div id="lastName-errors">
					@if (userProfileForm.get('lastName')?.errors?.['required']) {
						<div role="alert" aria-live="assertive">
		  	  	  <span style="color: red">Cognome è richiesto.</span>
		  	  	</div>
					}
		  	</div>
			}

		  <mat-form-field appearance="outline">
		    <mat-label>Email</mat-label>
		    <input matInput type="email" id="email" formControlName="email" placeholder="esempio@gmail.com" aria-required="true" aria-describedby="email-errors">
		  </mat-form-field>
			@if (userProfileForm.get('email')?.invalid && userProfileForm.get('email')?.touched) {
				<div id="email-errors">
					@if (userProfileForm.get('email')?.errors?.['required']) {
						<div role="alert" aria-live="assertive">
		  	  	  <span style="color: red">Email è richiesta.</span>
		  	  	</div>
					}
					@if (userProfileForm.get('email')?.errors?.['email']) {
						<div role="alert" aria-live="assertive">
		  	  	  <span style="color: red">Formato email non valido.</span>
		  	  	</div>	
					}
		  	</div>
			}

		  <mat-form-field class="example-full-width" appearance="outline">
		    <mat-label>Animale</mat-label>

		  	<input #animalinput
		  	  type="text"
					placeholder="Seleziona un animale"
		  	  matInput
		  	  formControlName="animal"
					[matAutocomplete]="auto"
		  	  (input)="filter()"
		  	  (focus)="filter()">

		  	<button mat-icon-button matSuffix aria-label="Apri selezione animale">
		  	  <mat-icon>pets</mat-icon>
		  	</button>

		  	<mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn">
		  	  @for (option of filteredAnimalOptions; track option) {
		  	    <mat-option [value]="option" aria-label="{{option.name}}">{{option.name}}</mat-option>
		  	  }
		  	</mat-autocomplete>
		  </mat-form-field>

		  <div formGroupName="address" aria-labelledby="address-section">
		    <h3 id="address-section">Indirizzo</h3>
		    <mat-form-field appearance="outline">
		  	  <mat-label>Via</mat-label>
		  	  <input matInput id="street" type="text" formControlName="street" aria-label="Via">
		  	</mat-form-field>
		    <mat-form-field appearance="outline">
		  	  <mat-label>Città</mat-label>
		  	  <input matInput id="city" type="text" formControlName="city" aria-label="Città">
		  	</mat-form-field>
		    <mat-form-field appearance="outline">
		  	  <mat-label>CAP</mat-label>
		  	  <input matInput id="zip" type="text" formControlName="zip" aria-label="CAP">
		  	</mat-form-field>
		  </div>

			<div formArrayName="phoneNumbers" aria-labelledby="phone-section">
		  	<h3 id="phone-section">Numeri di Telefono</h3>
		    @for(phoneControl of phoneNumbers.controls; let i = $index; track $index) {
		      <div class="phone-row">
		    	  <mat-form-field appearance="outline">
		    	    <mat-label>Telefono {{ i + 1 }}</mat-label>
		    	    <input
		    	      matInput
		    	      type="text"
		    	      [formControlName]="i"
		    	      [attr.aria-label]="'Numero di telefono ' + (i + 1)"
		    	    >
		    	  </mat-form-field>
		    	  <button
		    	    mat-button
		    	    color="warn"
		    	    type="button"
		    	    (click)="removePhoneNumber(i)"
		    	    [attr.aria-label]="'Rimuovi numero ' + (i + 1)"
		    	  >
		    	    Rimuovi
		    	  </button>
		    	</div>
		    }
		    <button
		  	  mat-raised-button
		  	  type="button"
		  	  (click)="addPhoneNumber()"
		  	  aria-label="Aggiungi un nuovo numero di telefono"
		  	>
		  	  Aggiungi Numero
		  	</button>
		  </div>

			<button
			  mat-raised-button
			  type="button"
			  (click)="toggleFormDisabled()"
			  [attr.aria-label]="userProfileForm.disabled ? 'Abilita il modulo' : 'Disabilita il modulo'"
			>
			  {{ userProfileForm.disabled ? 'Abilita Form' : 'Disabilita Form' }}
			</button>
		
			<div>
			  <button
			    mat-raised-button
			    color="primary"
			    type="submit"
			    aria-label="Salva il profilo"
			  >
			    Salva Profilo
			  </button>
			</div>
		</form>

		<!-- Accessibilità nascosta per screen reader -->
		<div aria-live="polite" class="visually-hidden">
		  {{ userProfileForm.status === 'INVALID' ? 'Il form contiene errori.' : '' }}
		</div>
	</div>

	<hr>
</div>
